import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "orientation"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { useSlotProps as $aBEni$useSlotProps, useDOMRef as $aBEni$useDOMRef, useStyleProps as $aBEni$useStyleProps, classNames as $aBEni$classNames } from "@react-spectrum/utils";
import $aBEni$react from "react";
import { useSeparator as $aBEni$useSeparator } from "@react-aria/separator";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $7a9eac509b76fa30$exports = {};
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule", function () {
  return $7a9eac509b76fa30$export$9ebf9cdaed6878bc;
}, function (v) {
  return $7a9eac509b76fa30$export$9ebf9cdaed6878bc = v;
});
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--large", function () {
  return $7a9eac509b76fa30$export$243baa0ec4ab58cc;
}, function (v) {
  return $7a9eac509b76fa30$export$243baa0ec4ab58cc = v;
});
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--medium", function () {
  return $7a9eac509b76fa30$export$a8d73b58ca350eb9;
}, function (v) {
  return $7a9eac509b76fa30$export$a8d73b58ca350eb9 = v;
});
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--small", function () {
  return $7a9eac509b76fa30$export$b4b727880cfe37d;
}, function (v) {
  return $7a9eac509b76fa30$export$b4b727880cfe37d = v;
});
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--horizontal", function () {
  return $7a9eac509b76fa30$export$563c1b24466c05b8;
}, function (v) {
  return $7a9eac509b76fa30$export$563c1b24466c05b8 = v;
});
$parcel$export($7a9eac509b76fa30$exports, "spectrum-Rule--vertical", function () {
  return $7a9eac509b76fa30$export$76f93463a8fc15a8;
}, function (v) {
  return $7a9eac509b76fa30$export$76f93463a8fc15a8 = v;
});
var $7a9eac509b76fa30$export$9ebf9cdaed6878bc;
var $7a9eac509b76fa30$export$243baa0ec4ab58cc;
var $7a9eac509b76fa30$export$a8d73b58ca350eb9;
var $7a9eac509b76fa30$export$b4b727880cfe37d;
var $7a9eac509b76fa30$export$563c1b24466c05b8;
var $7a9eac509b76fa30$export$76f93463a8fc15a8;
$7a9eac509b76fa30$export$9ebf9cdaed6878bc = "spectrum-Rule_612bb8";
$7a9eac509b76fa30$export$243baa0ec4ab58cc = "spectrum-Rule--large_612bb8";
$7a9eac509b76fa30$export$a8d73b58ca350eb9 = "spectrum-Rule--medium_612bb8";
$7a9eac509b76fa30$export$b4b727880cfe37d = "spectrum-Rule--small_612bb8";
$7a9eac509b76fa30$export$563c1b24466c05b8 = "spectrum-Rule--horizontal_612bb8";
$7a9eac509b76fa30$export$76f93463a8fc15a8 = "spectrum-Rule--vertical_612bb8";
var $269e81ee206e9515$var$sizeMap = {
  S: 'small',
  M: 'medium',
  L: 'large'
};
function $269e81ee206e9515$var$Divider(props, ref) {
  props = $aBEni$useSlotProps(props, 'divider');
  var _props = props,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'L' : _props$size,
    _props$orientation = _props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    otherProps = _objectWithoutProperties(_props, _excluded);
  var domRef = $aBEni$useDOMRef(ref);
  var _$aBEni$useStyleProps = $aBEni$useStyleProps(otherProps),
    styleProps = _$aBEni$useStyleProps.styleProps;
  var weight = $269e81ee206e9515$var$sizeMap[size];
  var Element = 'hr';
  if (orientation === 'vertical') Element = 'div';
  var _$aBEni$useSeparator = $aBEni$useSeparator(_objectSpread(_objectSpread({}, props), {}, {
      elementType: Element
    })),
    separatorProps = _$aBEni$useSeparator.separatorProps;
  return /*#__PURE__*/$aBEni$react.createElement(Element, _objectSpread(_objectSpread({}, styleProps), {}, {
    className: $aBEni$classNames( /*@__PURE__*/$parcel$interopDefault($7a9eac509b76fa30$exports), 'spectrum-Rule', "spectrum-Rule--".concat(weight), {
      'spectrum-Rule--vertical': orientation === 'vertical',
      'spectrum-Rule--horizontal': orientation === 'horizontal'
    }, styleProps.className),
    // @ts-ignore https://github.com/Microsoft/TypeScript/issues/28892
    ref: domRef
  }, separatorProps));
}
/**
 * Dividers bring clarity to a layout by grouping and dividing content in close proximity.
 * They can also be used to establish rhythm and hierarchy.
 */
var $269e81ee206e9515$export$2e0a83ec2e27ecbb = /*#__PURE__*/$aBEni$react.forwardRef($269e81ee206e9515$var$Divider);
export { $269e81ee206e9515$export$2e0a83ec2e27ecbb as Divider };